import { combineEpics } from 'redux-observable';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/fromPromise';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mapTo';
import 'rxjs/add/operator/switchMap';

import { isCurrentPageSel } from '@location';
import { allReportSel, navigateToRoster, usersReportSel } from '@shared';
import { SET_ORGANIZATION } from '@shared/duck/actions';
import { organizationGuidSel } from '@shared/duck/selectors/general.selectors';
import { userIdSel } from '@user';
import '@utils/rxjs.add.operator.catchAndReport';

import { advancementReportResponse } from './actions';
import {
  GENERATE_ADVANCEMENT_REPORT_REQUEST,
  GENERATE_ADVANCEMENT_REPORT_RESPONSE,
  OPEN_ADVANCEMENT_REPORT_MODAL,
  ROUTE_EDIT_ADVANCEMENT_REPORT,
  advancementReportRequest,
  generateAdvancementReportError,
  generateAdvancementReportResponse,
  loadAdvancementReport,
} from './advancementReport.actions';
import { poidSel, showAllUsersSel } from './advancementReport.selectors';
import { generateAdvancementReport } from './advancementReport.services';

const fetchAdvancementReport$ = (action$, state$) =>
  action$.ofType(GENERATE_ADVANCEMENT_REPORT_RESPONSE).switchMap(() => {
    const organizationGuid = organizationGuidSel(state$.value);
    return Observable.of(advancementReportRequest(organizationGuid));
  });

const loadSpecificAdvancementReport$ = (action$, state$) =>
  action$
    .ofType(OPEN_ADVANCEMENT_REPORT_MODAL, advancementReportResponse.type)
    .filter(({ type }) => {
      const state = state$.value;
      if (type == advancementReportResponse.type) {
        return !poidSel(state);
      }

      return !isCurrentPageSel(state, ROUTE_EDIT_ADVANCEMENT_REPORT);
    })
    .map(() => {
      const state = state$.value;
      const showAllUsers = showAllUsersSel(state);
      const userReports = usersReportSel(state);
      const allReports = allReportSel(state);

      return loadAdvancementReport(showAllUsers ? allReports : userReports);
    });

const cancelEditingReport$ = (action$, state$) =>
  action$
    .ofType(SET_ORGANIZATION)
    .filter(() => isCurrentPageSel(state$.value, ROUTE_EDIT_ADVANCEMENT_REPORT))
    .mapTo(navigateToRoster());

const generateAdvancementReportEpic$ = (action$, state$) =>
  action$
    .ofType(GENERATE_ADVANCEMENT_REPORT_REQUEST)
    .switchMap(({ payload }) => {
      const loggedInUserId = userIdSel(state$.value);
      return Observable.fromPromise(
        generateAdvancementReport({ ...payload, loggedInUserId }),
      )
        .map(generateAdvancementReportResponse)
        .catchAndReport(err =>
          Observable.of(generateAdvancementReportError(err)),
        );
    });

export default combineEpics(
  fetchAdvancementReport$,
  loadSpecificAdvancementReport$,
  cancelEditingReport$,
  generateAdvancementReportEpic$,
);
